import { useCallback, useEffect, useState } from "react"

import useViewerHotkeys from "./useViewerHotkeys"

export default function useEnvironmentSettingsPopover() {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = useCallback(() => setIsOpen(prev => !prev), [])
  useViewerHotkeys({ onToggleEnvironmentSettings: toggle })

  useEffect(() => {
    if (!isOpen) {
      return undefined
    }

    const controller = new AbortController()
    const { signal } = controller

    document.addEventListener('mousedown', (event) => {
      if (event.target.closest('.environment-settings')) {
        return
      }
      // The Bulb trigger toggles the popover itself; excluding it avoids a
      // close-then-reopen race between this listener and the button's onClick.
      if (event.target.closest('#inner-viewer-sidebar-bulb-button')) {
        return
      }

      setIsOpen(false)
    }, { capture: true, signal })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }, { signal })

    return () => controller.abort()
  }, [isOpen])

  return { isOpen, toggle }
}
